export default __webpack_public_path__ + "static/cabas.inspirations-b3ac74ba471904a1872a38f6955a0a79.jpg";